import { takeEvery, put, call, all, fork } from "redux-saga/effects";

// Registration Redux States
import {
    GET_STATE,
    GET_OCCUPATION,
    GET_RELATEDPERSONTYPE,
    GET_EDUCATION,
    GET_OCCUPATIONDETAILS,
    GET_ASSETDETAILS,
    GET_OTHERBANKACCOUNTS,
    GET_ACCOUNTTYPE,
    GET_ENTITYTYPE,
    GET_LOCATION,
    GET_BRANCH,
    GET_POI,
    GET_REASON_TO_BECOME_CUSTOMER,
} from "./actionTypes"
import {
    getStateSuccess,
    getStateFail,
    getOccupationSuccess,
    getOccupationFail,
    getRelatedPersonTypeSuccess,
    getRelatedPersonTypeFail,
    getEducationSuccess,
    getEducationFail,
    getOccupationDetailsSuccess,
    getOccupationDetailsFail,
    getAssetDetailsSuccess,
    getAssetDetailsFail,
    getOtherBankAccountsSuccess,
    getOtherBankAccountsFail,
    getAccountTypeSuccess,
    getAccountTypeFail,
    getEntityTypeSuccess,
    getEntityTypeFail,
    getLocationSuccess,
    getLocationFail,
    getBranchSuccess,
    getBranchFail,
    getPoiSuccess,
    getPoiFail,
    getReasonToBecomeCustomerSuccess,
    getReasonToBecomeCustomerFail,
} from "./actions"

import { getState } from "../../helpers/fakebackend_helper";

import { getOccupation } from "../../helpers/fakebackend_helper";

import { getRelatedPersonType } from "../../helpers/fakebackend_helper";

import { getEducation } from "../../helpers/fakebackend_helper";

import { getOccupationDetails } from "../../helpers/fakebackend_helper";

import { getAssetDetails } from "../../helpers/fakebackend_helper";

import { getOtherBankAccounts } from "../../helpers/fakebackend_helper";

import { getAccountType } from "../../helpers/fakebackend_helper";

import { getEntityType } from "../../helpers/fakebackend_helper";

import { getLocation } from "../../helpers/fakebackend_helper";

import { getBranch, LocationId } from "../../helpers/fakebackend_helper";

import { getPoi } from "../../helpers/fakebackend_helper";

import { getReasonToBecomeCustomer } from "../../helpers/fakebackend_helper";
 

//GetAll State
function* fetchStateData() {
    try {
        const response = yield call(getState)
        yield put(getStateSuccess(response))
    } catch (error) {
        yield put(getStateFail(error))
    }
}

//GetAll Occupation
function* fetchOccupationData() {
    try {
        const response = yield call(getOccupation)
        yield put(getOccupationSuccess(response))
    } catch (error) {
        yield put(getOccupationFail(error))
    }
}

//GetAll Related_Person_Type
function* fetchRelatedPersonTypeData() {
    try {
        const response = yield call(getRelatedPersonType)
        yield put(getRelatedPersonTypeSuccess(response))
    } catch (error) {
        yield put(getRelatedPersonTypeFail(error))
    }
}

//GetAll Education
function* fetchEducationData() {
    try {
        const response = yield call(getEducation)
        yield put(getEducationSuccess(response))
    } catch (error) {
        yield put(getEducationFail(error))
    }
}

//GetAll OccupationDetails
function* fetchOccupationDetailsData() {
    try {
        const response = yield call(getOccupationDetails)
        yield put(getOccupationDetailsSuccess(response))
    } catch (error) {
        yield put(getOccupationDetailsFail(error))
    }
}

//GetAll AssetDetails
function* fetchAssetDetailsData() {
    try {
        const response = yield call(getAssetDetails)
        yield put(getAssetDetailsSuccess(response))
    } catch (error) {
        yield put(getAssetDetailsFail(error))
    }
}

 //GetAll OtherBankAccounts
function* fetchOtherBankAccountsData() {
    try {
        const response = yield call(getOtherBankAccounts)
        yield put(getOtherBankAccountsSuccess(response))
    } catch (error) {
        yield put(getOtherBankAccountsFail(error))
    }
}

//GetAll AccountType
function* fetchAccountTypeData() {
    try {
        const response = yield call(getAccountType)
        yield put(getAccountTypeSuccess(response))
    } catch (error) {
        yield put(getAccountTypeFail(error))
    }
}

//GetAll EntityType
function* fetchEntityTypeData() {
    try {
        const response = yield call(getEntityType)
        yield put(getEntityTypeSuccess(response))
    } catch (error) {
        yield put(getEntityTypeFail(error))
    }
}

//GetAll Location
function* fetchLocationData() {
    try {
        const response = yield call(getLocation)
        yield put(getLocationSuccess(response))
    } catch (error) {
        yield put(getLocationFail(error))
    }
}

// GetByLocationId Branch
function* onGetBranch({ LocationId }) {
    try {
        debugger;
        const response = yield call(getBranch, LocationId);
        yield put(getBranchSuccess(response));
    } catch (error) {
        yield put(getBranchFail(error));
    }
}

//GetAll Poi
function* fetchpoiData() {
    try {
        const response = yield call(getPoi)
        yield put(getPoiSuccess(response))
    } catch (error) {
        yield put(getPoiFail(error))
    }
}

//GetAll Reason To Become a Customer
function* fetchReasonToBecomeCustomerData() {
    try {
        const response = yield call(getReasonToBecomeCustomer)
        yield put(getReasonToBecomeCustomerSuccess(response))
    } catch (error) {
        yield put(getReasonToBecomeCustomerFail(error))
    }
}

export function* watchFetchStateData() {
    yield takeEvery(GET_STATE, fetchStateData);
}

export function* watchFetchOccupationData() {
    yield takeEvery(GET_OCCUPATION, fetchOccupationData);
}

export function* watchfetchRelatedPersonTypeData() {
    yield takeEvery(GET_RELATEDPERSONTYPE, fetchRelatedPersonTypeData);
}

export function* watchFetchEducationData() {
    yield takeEvery(GET_EDUCATION, fetchEducationData);
}

export function* watchFetchOccupationDetailsData() {
    yield takeEvery(GET_OCCUPATIONDETAILS, fetchOccupationDetailsData);
}

export function* watchFetchAssetDetailsData() {
    yield takeEvery(GET_ASSETDETAILS, fetchAssetDetailsData);
}

export function* watchFetchOtherBankAccountsData() {
    yield takeEvery(GET_OTHERBANKACCOUNTS, fetchOtherBankAccountsData);
}

export function* watchFetchAccountTypeData() {
    yield takeEvery(GET_ACCOUNTTYPE, fetchAccountTypeData);
}

export function* watchFetchEntityTypeData() {
    yield takeEvery(GET_ENTITYTYPE, fetchEntityTypeData);
}

export function* watchFetchLocationData() {
    yield takeEvery(GET_LOCATION, fetchLocationData);
}

export function* watchFetchpoiData() {
    yield takeEvery(GET_POI, fetchpoiData);
}

export function* watchFetchReasonData() {
    yield takeEvery(GET_REASON_TO_BECOME_CUSTOMER, fetchReasonToBecomeCustomerData);
}

function* registrationSaga() {
    yield all([fork(watchFetchStateData)]);
    yield all([fork(watchFetchOccupationData)]);
    yield all([fork(watchfetchRelatedPersonTypeData)]);
    yield all([fork(watchFetchEducationData)]);
    yield all([fork(watchFetchOccupationDetailsData)]);
    yield all([fork(watchFetchAssetDetailsData)]);
    yield all([fork(watchFetchOtherBankAccountsData)]);
    yield all([fork(watchFetchAccountTypeData)]);
    yield all([fork(watchFetchEntityTypeData)]);
    yield all([fork(watchFetchLocationData)]);
    yield takeEvery(GET_BRANCH, onGetBranch);
    yield all([fork(watchFetchpoiData)]);
    yield all([fork(watchFetchReasonData)]);
}

export default registrationSaga;